<div *ngIf="hasIndividual$|async">
  <h5 class="mt-0 mb-4 text-primary font-weight-bold text-blue">
    {{ "LandingPage.service-heading-individual" | translate }}
  </h5>

  <div *ngIf="file$|async" class="row pb-4">
    <div class="col-md-12">
      <h6 class="font-weight-bold">
        {{ "LandingFilingPage.income-heading" | translate }}
      </h6>
      <h6 class="font-weight-bold font-14 mb-1">
        {{ "LandingFilingPage.income-step-1-heading" | translate }}
      </h6>
      <div class="pl-lg-3 mb-2">
        <dl>
          <dt class="mb-2">
            {{ "LandingFilingPage.income-step-1-sub-a" | translate }}
          </dt>
          <!--          <dt class="mb-2">-->
          <!--            {{ "LandingFilingPage.income-step-1-sub-b" | translate }}-->
          <!--          </dt>-->
          <dt>
            {{ "LandingFilingPage.income-step-1-sub-c" | translate }}
          </dt>
          <dd class="mb-2">
            {{ "LandingFilingPage.income-step-1-sub-c-part-1"| translate }}
          </dd>
          <dt class="mb-2">
            {{ "LandingFilingPage.income-step-1-sub-d" | translate }}
          </dt>
          <!--          <dt>-->
          <!--            {{ "LandingFilingPage.income-step-1-sub-e" | translate }}-->
          <!--          </dt>-->
        </dl>
      </div>
      <h6 class="font-weight-bold my-3 font-14">
        {{ "LandingFilingPage.income-step-2-heading" | translate }}
      </h6>
      <h6 class="font-weight-bold my-3 font-14">
        {{ "LandingFilingPage.income-step-3-heading" | translate }}
      </h6>
      <h6 class="font-weight-bold my-3 font-14">
        {{ "LandingFilingPage.income-step-4-heading" | translate }}
      </h6>
      <h6 class="font-weight-bold my-3 font-14">
        {{ "LandingFilingPage.income-step-5-heading" | translate }}
      </h6>

      <div *ngIf="!isClosed((config$| async)?.components?.individual?.eFileCloseDate)" class="d-flex">
        <button (click)="onRedirect('/individual/filings')" 
          class="btn btn-theme-color btn-primary btn-sm py-1 text-white shadow-none rounded-0"
          [attr.aria-label]="'Buttons.file-online-btn' | translate"
          tabindex="0"
          role="button">
          {{ "Buttons.file-online-btn" | translate }}
        </button>
      </div>
      <div *ngIf="isClosed((config$| async)?.components?.individual?.eFileCloseDate)" class="d-flex font-weight-bolder font-14">
        {{ "LandingFilingPage.opens" | translate }}
        <span class="ml-2  text-primary">{{ openDate | date:"MM/dd/yyyy" }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="estimateLookups$|async" class="row pb-4">
    <div class="col-md-12">
      <h6 class="font-weight-bold">
        {{ "LandingPage.estimates-heading" | translate }}
      </h6>
      <div class="pl-lg-3 mb-1">
        <dl>
          <dt class="mb-2">
            {{ "LandingPage.estimates-sub-a" | translate }}
          </dt>
        </dl>
      </div>
      <div class="d-flex">
        <a (click)="lookup()" 
            class="btn btn-theme-color pay-online btn-primary btn-sm py-1 text-white shadow-none rounded-0"
            href="javascript:"
            role="button" 
            tabindex="0" 
            [attr.aria-label]="'Buttons.lookup-btn' | translate">
          {{ "Buttons.lookup-btn" | translate }}
        </a>
      </div>
    </div>
  </div>

  <div *ngIf="payments$|async" class="row pb-4">
    <div class="col-md-12">
      <h6 class="font-weight-bold">
        {{ "LandingPage.income-heading" | translate }}
      </h6>

      <h6 class="font-weight-bold font-14 mb-1 ">
        {{ "LandingPage.income-step-1-heading" | translate }}
      </h6>
      <p class="mb-2" style="color: black">
        {{ "LandingPage.income-step-1-description" | translate }}
      </p>

      <h6 class="font-weight-bold font-14 mb-1">
        {{ "LandingPage.income-step-2-heading" | translate }}
      </h6>
      <p class="mb-2">
        {{ "LandingPage.income-step-2-description" | translate: { processingFee, feeMinimum } }}
      </p>

      <h6 class="font-weight-bold font-14 mb-1">
        {{ "LandingPage.income-step-3-heading" | translate }}
      </h6>
      <p class="mb-2">
        {{ "LandingPage.income-step-3-description" | translate }}
      </p>

      <div class="d-flex">
        <button (click)="onRedirect('/individual/payments')" 
           class="btn btn-theme-color btn-primary btn-sm py-1 text-white shadow-none rounded-0"
           tabindex="0"
           role="button"
           [attr.aria-label]="'Buttons.pay-online-btn' | translate">
          {{ "Buttons.pay-online-btn" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
